// // // import { useState, useEffect, useRef } from "react";
// // // import {
// // //   Card,
// // //   CardContent,
// // //   Typography,
// // //   TextField,
// // //   Button,
// // //   Box,
// // //   FormControl,
// // //   InputLabel,
// // //   Select,
// // //   MenuItem,
// // //   FormGroup,
// // //   FormControlLabel,
// // //   Checkbox,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   Snackbar,
// // //   Alert,
// // // } from "@mui/material";

// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";
// // // import CalendarCheckbox from "../components/SmallCalendar";

// // // const AppointmentForm = () => {
// // //   const [error, setError] = useState("");
// // //   const [staffUsers, setStaffUsers] = useState([]);
// // //   const [clientUsers, setClientUsers] = useState([]);
// // //   const [selectedClient, setSelectedClient] = useState("");
// // //   const [selectedStaff, setSelectedStaff] = useState("");
// // //   const [isSendEmail, setIsSendEmail] = useState(false);
// // //   const [isSendSMS, setIsSendSMS] = useState(false);
// // //   const [smsLanguage, setSmsLanguage] = useState("en"); // Language for SMS (en or el)
// // //   const [earlierPatientsList, setEarlierPatientsList] = useState([]);
// // //   const [selectedDate, setSelectedDate] = useState("");
// // //   const [selectedDateCalendar, setSelectedDateCalendar] = useState(null);
// // //   // eslint-disable-next-line
// // //   const [earlierDate, setEarlierDate] = useState(""); // New state for earlier date
// // //   const [loading, setLoading] = useState(false);
// // //   const [snackbarState, setSnackbarState] = useState({
// // //     appointment: { open: false, message: "" },
// // //     email: { open: false, message: "" },
// // //     sms: { open: false, message: "" },
// // //   });

// // //   const { t } = useTranslation();

// // //   const dateRef = useRef(null);
// // //   const clientRef = useRef(null);
// // //   const timestartRef = useRef(null);
// // //   const timeendRef = useRef(null);
// // //   const staffRef = useRef(null);
// // //   const earlierDateRef = useRef(null); // New ref for earlier date

// // //   useEffect(() => {
// // //     if (selectedDate && selectedStaff) {
// // //       getEarlierPatients(selectedDate, selectedStaff);
// // //     }
// // //   }, [selectedDate, selectedStaff]);

// // //   const getEarlierPatients = (date, staff) => {
// // //     setLoading(true);
// // //     axiosClient
// // //       .get(`api/print_appointments/?earlier_date=${date}&staff=${staff}`)
// // //       .then(({ data }) => {
// // //         console.log("Earlier Patients Data:", data);
// // //         if (Array.isArray(data)) {
// // //           setEarlierPatientsList(data);
// // //         } else {
// // //           setError("Invalid patient data received.");
// // //         }
// // //       })
// // //       .catch((err) => {
// // //         setError("Failed to load earlier patients.");
// // //       })
// // //       .finally(() => {
// // //         setLoading(false);
// // //       });
// // //   };

// // //   // const formatDate = (date) => {
// // //   //   if (!date) return "";
// // //   //   const year = date.getFullYear();
// // //   //   const month = String(date.getMonth() + 1).padStart(2, "0");
// // //   //   const day = String(date.getDate()).padStart(2, "0");
// // //   //   return `${year}-${month}-${day}`;
// // //   // };

// // //   const clearForm = () => {
// // //     setSelectedClient("");
// // //     setSelectedStaff("");
// // //     setSelectedDate("");
// // //     setSelectedDateCalendar(null);
// // //     setEarlierDate(""); // Reset earlier date
// // //     setIsSendEmail(false);
// // //     setIsSendSMS(false);
// // //     setEarlierPatientsList([]);
// // //     setError("");
// // //     if (dateRef.current) dateRef.current.value = "";
// // //     if (timestartRef.current) timestartRef.current.value = "";
// // //     if (timeendRef.current) timeendRef.current.value = "";
// // //     if (earlierDateRef.current) earlierDateRef.current.value = ""; // Clear earlier date field
// // //   };

// // //   const handleSubmit = async (event) => {
// // //     event.preventDefault();
// // //     setError("");
// // //     setSnackbarState({
// // //       appointment: { open: false, message: "" },
// // //       email: { open: false, message: "" },
// // //       sms: { open: false, message: "" },
// // //     });

// // //     const payload = {
// // //       client_id: selectedClient,
// // //       staff_id: selectedStaff,
// // //       appointment_start_time_str: timestartRef.current.value,
// // //       appointment_finish_time_str: timeendRef.current.value,
// // //       appointment_date: dateRef.current.value,
// // //       earlier_date: earlierDateRef.current.value || "", // Include earlier date
// // //     };

// // //     if (
// // //       !selectedClient ||
// // //       !selectedStaff ||
// // //       !payload.appointment_start_time_str ||
// // //       !payload.appointment_finish_time_str ||
// // //       !payload.appointment_date
// // //     ) {
// // //       setError("Please fill out all required fields.");
// // //       return;
// // //     }

// // //     // Validate that earlier_date is before appointment_date if set
// // //     if (payload.earlier_date && payload.appointment_date) {
// // //       const earlierDateObj = new Date(payload.earlier_date);
// // //       const apptDate = new Date(payload.appointment_date);
// // //       if (earlierDateObj >= apptDate) {
// // //         setError("Earlier date must be before the appointment date.");
// // //         return;
// // //       }
// // //     }

// // //     try {
// // //       const res = await axiosClient.post("api/appointment/", payload);
// // //       if (res?.status === 201) {
// // //         setSnackbarState((prev) => ({
// // //           ...prev,
// // //           appointment: { open: true, message: t("Appointment added successfully!") },
// // //         }));
// // //         if (isSendEmail) {
// // //           await handleSendEmail(res?.data?.id);
// // //         }
// // //         if (isSendSMS) {
// // //           await handleSendSMS(res?.data?.id);
// // //         }
// // //         clearForm();
// // //       }
// // //     } catch (err) {
// // //       setError(err?.response?.data?.error || t("An unexpected error occurred."));
// // //     }
// // //   };

// // //   const handleSendEmail = async (id) => {
// // //     if (!id) {
// // //       setError(t("Cannot send email: Invalid appointment ID."));
// // //       return;
// // //     }
// // //     try {
// // //       await axiosClient.post("api/send_email/", { appointment_id: id });
// // //       setSnackbarState((prev) => ({
// // //         ...prev,
// // //         email: { open: true, message: t("Email sent successfully!") },
// // //       }));
// // //     } catch (error) {
// // //       setError(t("Failed to send email. Please try again."));
// // //       console.error(error);
// // //     }
// // //   };

// // //   const handleSendSMS = async (id) => {
// // //     if (!id) {
// // //       setError(t("Cannot send SMS: Invalid appointment ID."));
// // //       return;
// // //     }
// // //     try {
// // //       await axiosClient.post(`api/send_appointment_info/${id}/`, {
// // //         language: smsLanguage,
// // //       });
// // //       setSnackbarState((prev) => ({
// // //         ...prev,
// // //         sms: { open: true, message: t("SMS sent successfully!") },
// // //       }));
// // //     } catch (error) {
// // //       setError(t("Failed to send SMS. Please try again."));
// // //       console.error(error);
// // //     }
// // //   };

// // //   const handleCloseSnackbar = (type) => {
// // //     setSnackbarState((prev) => ({
// // //       ...prev,
// // //       [type]: { ...prev[type], open: false },
// // //     }));
// // //   };

// // //   useEffect(() => {
// // //     Promise.all([
// // //       axiosClient.get("api/staff-users/"),
// // //       axiosClient.get("api/client-users/"),
// // //     ]).then(([staffRes, clientRes]) => {
// // //       setStaffUsers(staffRes?.data);
// // //       setClientUsers(clientRes?.data);
// // //     });
// // //   }, []);

// // //   const handleDateChange = (e) => {
// // //     setSelectedDate(e.target.value);
// // //   };

// // //   const handleEarlierDateChange = (e) => {
// // //     setEarlierDate(e.target.value);
// // //   };

// // //   useEffect(() => {
// // //     if (selectedStaff) {
// // //       const filteredData = clientUsers.filter(
// // //         (user) => user.assigned_staff === selectedStaff
// // //       );
// // //       setClientUsers(filteredData);
// // //     }
// // //     // eslint-disable-next-line
// // //   }, [selectedStaff]);

// // //   return (
// // //     <Card elevation={16}>
// // //       <CardContent>
// // //         <Typography variant="h5" gutterBottom sx={{ fontSize: "1.2rem" }}>
// // //           {t("Appointment Details")}
// // //         </Typography>
// // //         {error && (
// // //           <Alert severity="error" sx={{ marginBottom: "1rem" }}>
// // //             {error}
// // //           </Alert>
// // //         )}
// // //         <form onSubmit={handleSubmit}>
// // //           <Box sx={{ "& .MuiTextField-root": { marginBottom: "1rem" } }}>
// // //             <FormControl
// // //               fullWidth
// // //               variant="outlined"
// // //               sx={{ marginBottom: "1rem" }}
// // //               required
// // //             >
// // //               <InputLabel id="staff-select-label">
// // //                 {t("Select Staff")}
// // //               </InputLabel>
// // //               <Select
// // //                 labelId="staff-select-label"
// // //                 inputRef={staffRef}
// // //                 value={selectedStaff}
// // //                 onChange={(e) => setSelectedStaff(e.target.value)}
// // //                 label={t("Select Staff")}
// // //               >
// // //                 {staffUsers.map((st) => (
// // //                   <MenuItem
// // //                     value={st.id}
// // //                     lastname={st.custom_user.last_name}
// // //                   >{`${st.custom_user.first_name} ${st.custom_user.last_name}`}</MenuItem>
// // //                 ))}
// // //               </Select>
// // //             </FormControl>
// // //             <FormControl
// // //               fullWidth
// // //               variant="outlined"
// // //               sx={{ marginBottom: "1rem" }}
// // //               required
// // //             >
// // //               <InputLabel id="client-select-label">
// // //                 {t("Select Client")}
// // //               </InputLabel>
// // //               <Select
// // //                 labelId="client-select-label"
// // //                 inputRef={clientRef}
// // //                 value={selectedClient}
// // //                 onChange={(e) => setSelectedClient(e.target.value)}
// // //                 label={t("Select Client")}
// // //               >
// // //                 {clientUsers.map((user) => (
// // //                   <MenuItem
// // //                     value={user.id}
// // //                     lastname={user.custom_user.last_name}
// // //                   >{`${user.custom_user.first_name} ${user.custom_user.last_name}`}</MenuItem>
// // //                 ))}
// // //               </Select>
// // //             </FormControl>
// // //             <TextField
// // //               fullWidth
// // //               type="date"
// // //               label={t("Date of Appointment")}
// // //               variant="outlined"
// // //               onChange={handleDateChange}
// // //               InputLabelProps={{ shrink: true }}
// // //               inputRef={dateRef}
// // //               required
// // //             />
// // //             <TextField
// // //               fullWidth
// // //               type="time"
// // //               label={t("Time of Appointment (start)")}
// // //               variant="outlined"
// // //               InputLabelProps={{ shrink: true }}
// // //               inputRef={timestartRef}
// // //               required
// // //             />
// // //             <TextField
// // //               fullWidth
// // //               type="time"
// // //               label={t("Time of Appointment (end)")}
// // //               variant="outlined"
// // //               InputLabelProps={{ shrink: true }}
// // //               inputRef={timeendRef}
// // //               required
// // //             />
// // //           </Box>
// // //           <TextField
// // //             fullWidth
// // //             type="date"
// // //             label={t("Earlier Appointment Date (If any)")}
// // //             variant="outlined"
// // //             onChange={handleEarlierDateChange}
// // //             InputLabelProps={{ shrink: true }}
// // //             inputRef={earlierDateRef}
// // //           />
// // //           <Box
// // //             sx={{
// // //               display: "flex",
// // //               flexDirection: { xs: "column", sm: "row" },
// // //               justifyContent: "space-between",
// // //               gap: 2,
// // //               marginTop: 4,
// // //             }}
// // //           >
// // //             <FormGroup>
// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={isSendEmail}
// // //                     onChange={(e) => setIsSendEmail(e.target.checked)}
// // //                   />
// // //                 }
// // //                 label={t("Send Email to client")}
// // //               />
// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={isSendSMS}
// // //                     onChange={(e) => setIsSendSMS(e.target.checked)}
// // //                   />
// // //                 }
// // //                 label={t("Send SMS to client")}
// // //               />
// // //               {isSendSMS && (
// // //                 <FormControl size="small" sx={{ minWidth: 120, ml: 4, mb: 1 }}>
// // //                   <InputLabel>{t("SMS Language")}</InputLabel>
// // //                   <Select
// // //                     value={smsLanguage}
// // //                     label={t("SMS Language")}
// // //                     onChange={(e) => setSmsLanguage(e.target.value)}
// // //                   >
// // //                     <MenuItem value="en">{t("English")}</MenuItem>
// // //                     <MenuItem value="el">{t("Greek")}</MenuItem>
// // //                   </Select>
// // //                 </FormControl>
// // //               )}
// // //               <CalendarCheckbox
// // //                 selectedDateCalendar={selectedDateCalendar}
// // //                 setSelectedDateCalendar={setSelectedDateCalendar}
// // //                 selectedClient={selectedClient}
// // //               />
// // //             </FormGroup>
// // //             <Box
// // //               sx={{
// // //                 flex: { xs: 1, sm: 0.4 },
// // //                 maxHeight: "300px",
// // //                 overflowY: "auto",
// // //                 bgcolor: "background.paper",
// // //                 borderRadius: 2,
// // //                 boxShadow: 2,
// // //                 p: { xs: 1.5, sm: 2 },
// // //                 border: "1px solid",
// // //                 borderColor: "grey.300",
// // //                 mt: { xs: 2, sm: 0 },
// // //               }}
// // //             >
// // //               <Typography
// // //                 variant="h6"
// // //                 sx={{
// // //                   fontSize: { xs: ".9rem", sm: "1.1rem" },
// // //                   fontWeight: "medium",
// // //                   mb: 1.5,
// // //                   color: "text.primary",
// // //                 }}
// // //               >
// // //                 {t("Earlier Appointments for Selected Patient and Doctor")}
// // //               </Typography>
// // //               {loading ? (
// // //                 <Typography
// // //                   variant="body2"
// // //                   sx={{ color: "text.secondary", textAlign: "center" }}
// // //                 >
// // //                   {t("Loading...")}
// // //                 </Typography>
// // //               ) : earlierPatientsList.length === 0 ? (
// // //                 <Typography
// // //                   variant="body2"
// // //                   sx={{ color: "text.secondary", textAlign: "center" }}
// // //                 >
// // //                   {t("No earlier appointments found.")}
// // //                 </Typography>
// // //               ) : (
// // //                 <List dense sx={{ p: 0 }}>
// // //                   {earlierPatientsList.map((patient) => (
// // //                     <ListItem
// // //                       key={patient.id}
// // //                       sx={{
// // //                         py: 0.5,
// // //                         "&:not(:last-child)": { borderBottom: "1px solid", borderColor: "grey.200" },
// // //                       }}
// // //                     >
// // //                       <ListItemText
// // //                         primary={
// // //                           <Typography
// // //                             variant="body2"
// // //                             sx={{ color: "text.secondary", textAlign: "center" }}
// // //                           >
// // //                             {t("Yes, {{clientName}} has an earlier appointment.", {
// // //                               clientName: `${patient.client_name} ${patient.client_surname}`,
// // //                             })}
// // //                           </Typography>
// // //                         }
// // //                       />
// // //                     </ListItem>
// // //                   ))}
// // //                 </List>
// // //               )}
// // //             </Box>
// // //           </Box>
// // //           <Box sx={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
// // //             <Button type="submit" variant="contained" color="primary">
// // //               {t("Submit")}
// // //             </Button>
// // //             <Button
// // //               variant="outlined"
// // //               color="secondary"
// // //               onClick={clearForm}
// // //             >
// // //               {t("Clear")}
// // //             </Button>
// // //           </Box>
// // //         </form>
// // //         <Snackbar
// // //           open={snackbarState.appointment.open}
// // //           autoHideDuration={6000}
// // //           onClose={() => handleCloseSnackbar("appointment")}
// // //           anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // //         >
// // //           <Alert
// // //             onClose={() => handleCloseSnackbar("appointment")}
// // //             severity="success"
// // //             sx={{ width: "100%" }}
// // //           >
// // //             {snackbarState.appointment.message}
// // //           </Alert>
// // //         </Snackbar>
// // //         <Snackbar
// // //           open={snackbarState.email.open}
// // //           autoHideDuration={6000}
// // //           onClose={() => handleCloseSnackbar("email")}
// // //           anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // //         >
// // //           <Alert
// // //             onClose={() => handleCloseSnackbar("email")}
// // //             severity="success"
// // //             sx={{ width: "100%" }}
// // //           >
// // //             {snackbarState.email.message}
// // //           </Alert>
// // //         </Snackbar>
// // //         <Snackbar
// // //           open={snackbarState.sms.open}
// // //           autoHideDuration={6000}
// // //           onClose={() => handleCloseSnackbar("sms")}
// // //           anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // //         >
// // //           <Alert
// // //             onClose={() => handleCloseSnackbar("sms")}
// // //             severity="success"
// // //             sx={{ width: "100%" }}
// // //           >
// // //             {snackbarState.sms.message}
// // //           </Alert>
// // //         </Snackbar>
// // //       </CardContent>
// // //     </Card>
// // //   );
// // // };

// // // export default AppointmentForm;


// // import React, { useState, useEffect } from "react";
// // import { 
// //   Box, TextField, Button, MenuItem, Select, 
// //   FormControl, InputLabel, Typography, Grid, Alert 
// // } from "@mui/material";
// // import { useTranslation } from "react-i18next";
// // import axiosClient from "../axiosClient";

// // const AppointmentForm = ({ selectedDate, onSave }) => {
// //   const { t } = useTranslation();
// //   const [technicians, setTechnicians] = useState([]);
// //   const [issues, setIssues] = useState([]);
// //   const [loading, setLoading] = useState(true);
  
// //   const [formData, setFormData] = useState({
// //     start_time: selectedDate || "",
// //     end_time: "",
// //     technician_id: "",
// //     issue_id: "",
// //     notes: "",
// //   });

// //   const [selectedIssueRoom, setSelectedIssueRoom] = useState("");

// //   // 1. Fetch Technicians and Issues when form opens
// //   useEffect(() => {
// //     Promise.all([
// //       axiosClient.get("auth/technicians/"),
// //       axiosClient.get("api/issues/")
// //     ])
// //     .then(([techRes, issueRes]) => {
// //       setTechnicians(techRes.data || []);
// //       setIssues(issueRes.data || []);
// //       setLoading(false);
// //     })
// //     .catch(err => console.error("Error loading form data", err));
// //   }, []);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: value }));

// //     // 🆕 If the issue changes, find and display its room number
// //     if (name === "issue_id") {
// //       const issue = issues.find(i => i.id === value);
// //       setSelectedIssueRoom(issue?.room_number || t("No Room Assigned"));
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       await axiosClient.post("api/appointments/", formData);
// //       onSave(); // Close modal and refresh calendar
// //     } catch (err) {
// //       console.error("Error saving appointment", err);
// //     }
// //   };

// //   return (
// //     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
// //       <Typography variant="h6" mb={2}>{t("Schedule Technical Task")}</Typography>
      
// //       <Grid container spacing={2}>
// //         {/* Technician Selection */}
// //         <Grid item xs={12}>
// //           <FormControl fullWidth required>
// //             <InputLabel>{t("Select Technician")}</InputLabel>
// //             <Select
// //               name="technician_id"
// //               value={formData.technician_id}
// //               label={t("Select Technician")}
// //               onChange={handleChange}
// //             >
// //               {technicians.map(tech => (
// //                 <MenuItem key={tech.id} value={tech.user}>
// //                   {tech.user_first_name} {tech.user_last_name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //         </Grid>

// //         {/* Issue Selection */}
// //         <Grid item xs={12}>
// //           <FormControl fullWidth required>
// //             <InputLabel>{t("Select Issue")}</InputLabel>
// //             <Select
// //               name="issue_id"
// //               value={formData.issue_id}
// //               label={t("Select Issue")}
// //               onChange={handleChange}
// //             >
// //               {issues.map(issue => (
// //                 <MenuItem key={issue.id} value={issue.id}>
// //                   #{issue.id} - {issue.title}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //         </Grid>

// //         {/* 🆕 Room Display (Auto-filled from Issue) */}
// //         {selectedIssueRoom && (
// //           <Grid item xs={12}>
// //             <Alert icon={false} severity="info" sx={{ fontWeight: 'bold' }}>
// //               {t("Location")}: {selectedIssueRoom}
// //             </Alert>
// //           </Grid>
// //         )}

// //         <Grid item xs={6}>
// //           <TextField
// //             fullWidth
// //             label={t("Start Time")}
// //             type="datetime-local"
// //             name="start_time"
// //             value={formData.start_time}
// //             onChange={handleChange}
// //             InputLabelProps={{ shrink: true }}
// //             required
// //           />
// //         </Grid>

// //         <Grid item xs={6}>
// //           <TextField
// //             fullWidth
// //             label={t("End Time")}
// //             type="datetime-local"
// //             name="end_time"
// //             value={formData.end_time}
// //             onChange={handleChange}
// //             InputLabelProps={{ shrink: true }}
// //             required
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <TextField
// //             fullWidth
// //             multiline
// //             rows={2}
// //             label={t("Appointment Notes")}
// //             name="notes"
// //             value={formData.notes}
// //             onChange={handleChange}
// //           />
// //         </Grid>

// //         <Grid item xs={12}>
// //           <Button type="submit" variant="contained" fullWidth size="large">
// //             {t("Save Appointment")}
// //           </Button>
// //         </Grid>
// //       </Grid>
// //     </Box>
// //   );
// // };

// // export default AppointmentForm;


// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [technicians, setTechnicians] = useState([]);
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   const [formData, setFormData] = useState({
//     start_time: selectedDate || "",
//     end_time: "",
//     technician_user_id: "", // Matches backend requirement
//     issue_id: "",
//     room_number: "", // 🆕 Tracked in local state
//     notes: "",
//   });

//   // 1. Fetch Technicians and Issues when the form opens
//   useEffect(() => {
//     setLoading(true);
//     Promise.all([
//       axiosClient.get("auth/technicians/"),
//       axiosClient.get("api/issues/")
//     ])
//     .then(([techRes, issueRes]) => {
//       setTechnicians(techRes.data || []);
//       setIssues(issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading form data", err);
//       setError(t("Failed to load technicians or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     // Create updated state object
//     let updatedData = { ...formData, [name]: value };

//     // 🆕 LOGIC: If the issue changes, auto-fill the Room Number
//     if (name === "issue_id") {
//       const selectedIssue = issues.find(i => i.id === value);
//       updatedData.room_number = selectedIssue?.room_number || "";
//     }

//     setFormData(updatedData);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
    
//     try {
//       // POST the appointment to the backend
//       await axiosClient.post("api/appointments/", formData);
//       onSave(); // Close modal and refresh calendar
//     } catch (err) {
//       console.error("Error saving appointment", err.response?.data);
//       setError(err.response?.data?.error || t("Failed to save appointment."));
//     }
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" p={5}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//       <Typography variant="h6" mb={3} fontWeight="bold">
//         {t("Schedule Technical Task")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         {/* Technician Selection */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel id="tech-select-label">{t("Select Technician")}</InputLabel>
//             <Select
//               labelId="tech-select-label"
//               name="technician_user_id"
//               value={formData.technician_user_id}
//               label={t("Select Technician")}
//               onChange={handleChange}
//             >
//               {technicians.map(tech => (
//                 <MenuItem key={tech.id} value={tech.user}>
//                   {tech.user_first_name} {tech.user_last_name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* Issue Selection */}
//         <Grid item xs={12} sm={8}>
//           <FormControl fullWidth required>
//             <InputLabel id="issue-select-label">{t("Select Issue")}</InputLabel>
//             <Select
//               labelId="issue-select-label"
//               name="issue_id"
//               value={formData.issue_id}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   #{issue.id} - {issue.title}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* 🆕 Editable Room Number Field */}
//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label={t("Room Number")}
//             name="room_number"
//             value={formData.room_number}
//             onChange={handleChange}
//             variant="outlined"
//             placeholder={t("Auto-filled")}
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("Start Time")}
//             type="datetime-local"
//             name="start_time"
//             value={formData.start_time}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("End Time")}
//             type="datetime-local"
//             name="end_time"
//             value={formData.end_time}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             multiline
//             rows={3}
//             label={t("Task Notes")}
//             name="notes"
//             value={formData.notes}
//             onChange={handleChange}
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box display="flex" gap={2} justifyContent="flex-end">
//             <Button variant="contained" type="submit" size="large" sx={{ px: 5 }}>
//               {t("Save Task")}
//             </Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;

/////////////////////////////////////////////////////////////////


// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {

//   // console.log("HELLO: AppointmentForm component has loaded!");
//   const { t } = useTranslation();
//   const [technicians, setTechnicians] = useState([]);
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   const [formData, setFormData] = useState({
//     appointment_date: selectedDate ? selectedDate.split('T')[0] : "",
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", 
//     issue: "",
//     room_display: "", // 🆕 Local display for the room
//   });

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([
//       axiosClient.get("auth/users/?role=TECHNICIAN"),
//       axiosClient.get("api/issues/")
//     ])
//     .then(([techRes, issueRes]) => {
//       // Handle different possible data structures from backend
//       setTechnicians(techRes.data.results || techRes.data || []);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load technicians or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       // 🛠️ ROOM LOGIC: When an issue is selected, find its room number
//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Ensure the payload matches your Django Appointment model
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
//       await axiosClient.post("api/appointments/", payload);
//       onSave(); 
//     } catch (err) {
//       setError(t("Error saving appointment."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//       <Typography variant="h6" mb={3} fontWeight="bold">{t("ADD NEW APPOINTMENT")}</Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         {/* Technician Select */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Technician")}</InputLabel>
//             <Select
//               name="technician"
//               value={formData.technician}
//               label={t("Select Technician")}
//               onChange={handleChange}
//             >
//               {technicians.map(tech => (
//                 <MenuItem key={tech.id} value={tech.id}>
//                   {`${tech.first_name} ${tech.last_name} (${tech.email})`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* Issue Select */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* 🆕 ROOM NUMBER DISPLAY */}
//         {formData.room_display && (
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label={t("ROOM")}
//               value={formData.room_display}
//               InputProps={{ readOnly: true }}
//               variant="filled"
//               helperText={t("Location pulled from the issue report")}
//             />
//           </Grid>
//         )}

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button onClick={onSave} color="inherit">{t("CANCEL")}</Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;

///////////////////////////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [technicians, setTechnicians] = useState([]);
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   // Set initial date: Use selectedDate from calendar or default to today's date
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "",
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([
//       axiosClient.get("auth/users/?role=TECHNICIAN"),
//       axiosClient.get("api/issues/")
//     ])
//     .then(([techRes, issueRes]) => {
//       setTechnicians(techRes.data.results || techRes.data || []);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load technicians or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); // Clear previous errors
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       // Useful for debugging in F12 console
//       console.log("Submitting Appointment:", payload); 

//       await axiosClient.post("api/appointments/", payload);
//       onSave();
//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD NEW APPOINTMENT")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         {/* NEW: Date Selection Field */}
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Technician")}</InputLabel>
//             <Select
//               name="technician"
//               value={formData.technician}
//               label={t("Select Technician")}
//               onChange={handleChange}
//             >
//               {technicians.map(tech => (
//                 <MenuItem key={tech.id} value={tech.id}>
//                   {`${tech.first_name} ${tech.last_name} (${tech.email})`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {formData.room_display && (
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label={t("ROOM")}
//               value={formData.room_display}
//               InputProps={{ readOnly: true }}
//               variant="filled"
//               helperText={t("Location pulled from the issue report")}
//             />
//           </Grid>
//         )}

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button onClick={onSave} color="inherit">{t("CANCEL")}</Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;

//////////////////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [technicians, setTechnicians] = useState([]);
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   // Set initial date: Use selectedDate from calendar or default to today's date
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "",
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([
//       axiosClient.get("auth/users/?role=TECHNICIAN"),
//       axiosClient.get("api/issues/")
//     ])
//     .then(([techRes, issueRes]) => {
//       setTechnicians(techRes.data.results || techRes.data || []);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load technicians or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       console.log("Submitting Appointment:", payload); 

//       await axiosClient.post("api/appointments/", payload);

//       // FIX: Check if onSave exists (Calendar Mode). If not, redirect (Sidebar Mode).
//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         // Standard browser redirect to the view appointments page
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       // Log the actual server error to the console for debugging
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("Add New Appointment")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         {/* Date Field - Required for Sidebar Mode */}
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Technician")}</InputLabel>
//             <Select
//               name="technician"
//               value={formData.technician}
//               label={t("Select Technician")}
//               onChange={handleChange}
//             >
//               {technicians.map(tech => (
//                 <MenuItem key={tech.id} value={tech.id}>
//                   {`${tech.first_name} ${tech.last_name} (${tech.email})`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;


///////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress, Chip
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]); // Renamed from technicians
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   // Set initial date: Use selectedDate from calendar or default to today's date
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", // Keeping key as 'technician' for backend compatibility
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     // Fetching both TECHNICIAN and MAID roles to populate "Select Staff"
//     Promise.all([
//       axiosClient.get("auth/users/?role=TECHNICIAN,MAID"),
//       axiosClient.get("api/issues/")
//     ])
//     .then(([staffRes, issueRes]) => {
//       setStaffList(staffRes.data.results || staffRes.data || []);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load staff or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       await axiosClient.post("api/appointments/", payload);

//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       {/* Modification 1: Changed Title */}
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD TO CALENDAR")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         {/* Modification 2: Changed label to "Select Staff" and updated list */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Staff")}</InputLabel>
//             <Select
//               name="technician"
//               value={formData.technician}
//               label={t("Select Staff")}
//               onChange={handleChange}
//             >
//               {staffList.map(staff => (
//                 <MenuItem key={staff.id} value={staff.id}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                     <Typography>
//                       {`${staff.first_name} ${staff.last_name}`}
//                     </Typography>
//                     <Chip 
//                       label={staff.role} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ ml: 1, fontSize: '0.65rem', height: '20px' }} 
//                     />
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;



/////////////////////////////


// import React, { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
//   CircularProgress, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open",
//     assigned_technician: "",
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       setLoading(true);
//       try {
//         // Fetch users and filter for TECHNICIAN and MAID roles
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
        
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
        
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//         setError(t("Failed to load staff list."));
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStaff();
//   }, [t]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
      
//       // Reset form
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//       });
//     } catch (err) {
//       console.error("Submit Error:", err.response?.data);
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4} px={2}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           {/* Consistency: Matching the style of the Appointment Form */}
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField 
//                   fullWidth 
//                   label={t("Issue Title *")} 
//                   name="title" 
//                   value={formData.title} 
//                   onChange={handleChange} 
//                   required 
//                 />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField 
//                   fullWidth 
//                   label={t("Room Number *")} 
//                   name="room_number" 
//                   value={formData.room_number} 
//                   onChange={handleChange} 
//                   required 
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField 
//                   fullWidth 
//                   label={t("Description *")} 
//                   name="description" 
//                   multiline 
//                   rows={4} 
//                   value={formData.description} 
//                   onChange={handleChange} 
//                   required 
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select 
//                     name="priority" 
//                     value={formData.priority} 
//                     label={t("Priority")} 
//                     onChange={handleChange}
//                   >
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Updated Staff Select to match AppointmentForm style */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Select Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Select Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                           <Typography>
//                             {user.first_name || user.last_name 
//                               ? `${user.first_name || ''} ${user.last_name || ''}`.trim() 
//                               : user.email}
//                           </Typography>
//                           <Chip 
//                             label={user.user_role} 
//                             size="small" 
//                             variant="outlined" 
//                             sx={{ 
//                               ml: 1, 
//                               fontSize: '0.65rem', 
//                               height: '20px',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               borderColor: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                             }} 
//                           />
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* ACTION BUTTONS: Same layout as AppointmentForm */}
//               <Grid item xs={12}>
//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//                   <Button 
//                     variant="outlined" 
//                     color="inherit" 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: ""
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                   <Button 
//                     type="submit" 
//                     variant="contained" 
//                     color="primary"
//                   >
//                     {t("CREATE ISSUE")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


////////////////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress, Chip
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   // Set initial date: Use selectedDate from calendar or default to today's date
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", 
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     // Fetching both TECHNICIAN and MAID roles to populate "Select Staff"
//     Promise.all([
//       axiosClient.get("auth/users/"), // Getting all users to filter by role
//       axiosClient.get("api/issues/")
//     ])
//     .then(([userRes, issueRes]) => {
//       const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
      
//       // Filter for both TECHNICIAN and MAID roles as required
//       const assignable = allUsers.filter(u => 
//         u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//       );

//       setStaffList(assignable);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load staff or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       await axiosClient.post("api/appointments/", payload);

//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       {/* Title changed to ADD TO CALENDAR */}
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD TO CALENDAR")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         {/* Label changed to Select Staff with mixed role list */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               name="technician"
//               value={formData.technician}
//               label={t("Select Staff")}
//               onChange={handleChange}
//             >
//               {staffList.map(staff => (
//                 <MenuItem key={staff.id} value={staff.id}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                     <Typography>
//                       {`${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.email}
//                     </Typography>
//                     {/* Role Chips with colors matching the Issue log */}
//                     <Chip 
//                       label={staff.user_role} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ 
//                         ml: 1, 
//                         fontSize: '0.65rem', 
//                         height: '20px',
//                         color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                         borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                       }} 
//                     />
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;


// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress, Chip
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   // Set initial date: Use selectedDate from calendar or default to today's date
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", // Keep as 'technician' for backend compatibility
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     // Fetching both TECHNICIAN and MAID roles to populate "Select Staff"
//     Promise.all([
//       axiosClient.get("auth/users/"), 
//       axiosClient.get("api/issues/")
//     ])
//     .then(([userRes, issueRes]) => {
//       const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
      
//       // Filter for both TECHNICIAN and MAID roles
//       const assignable = allUsers.filter(u => 
//         u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//       );

//       setStaffList(assignable);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load staff or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       await axiosClient.post("api/appointments/", payload);

//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       {/* Title changed to ADD TO CALENDAR */}
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD TO CALENDAR")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         {/* REPLACED "Doctor" with "Staff" */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               name="technician"
//               value={formData.technician}
//               label={t("Select Staff")}
//               onChange={handleChange}
//             >
//               {staffList.map(staff => (
//                 <MenuItem key={staff.id} value={staff.id}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                     <Typography>
//                       {`${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.email}
//                     </Typography>
//                     {/* Role Chips with colors */}
//                     <Chip 
//                       label={staff.user_role} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ 
//                         ml: 1, 
//                         fontSize: '0.65rem', 
//                         height: '20px',
//                         color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                         borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                       }} 
//                     />
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;


//////////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress, Chip
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", 
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([
//       axiosClient.get("auth/users/"), 
//       axiosClient.get("api/issues/")
//     ])
//     .then(([userRes, issueRes]) => {
//       const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
      
//       // Filter for both roles: Technician and Maid
//       const assignable = allUsers.filter(u => 
//         u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//       );

//       setStaffList(assignable);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load staff or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       await axiosClient.post("api/appointments/", payload);

//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD TO CALENDAR")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         {/* Updated from Select Doctor to Select Staff */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               name="technician"
//               value={formData.technician}
//               label={t("Select Staff")}
//               onChange={handleChange}
//             >
//               {staffList.map(staff => (
//                 <MenuItem key={staff.id} value={staff.id}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                     <Typography>
//                       {`${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.email}
//                     </Typography>
//                     <Chip 
//                       label={staff.user_role} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ 
//                         ml: 1, 
//                         fontSize: '0.65rem', 
//                         height: '20px',
//                         color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                         borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                       }} 
//                     />
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;

/////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Box, TextField, Button, MenuItem, Select, 
//   FormControl, InputLabel, Typography, Grid, Alert,
//   CircularProgress, Chip
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentForm = ({ selectedDate, onSave }) => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]); 
//   const [issues, setIssues] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
  
//   const initialDate = selectedDate ? selectedDate.split('T')[0] : new Date().toISOString().split('T')[0];

//   const [formData, setFormData] = useState({
//     appointment_date: initialDate,
//     appointment_start: "09:00",
//     appointment_end: "10:00",
//     technician: "", // This matches the backend field name
//     issue: "",
//     room_display: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     // Fetch users and issues simultaneously
//     Promise.all([
//       axiosClient.get("auth/users/"), 
//       axiosClient.get("api/issues/")
//     ])
//     .then(([userRes, issueRes]) => {
//       const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
      
//       // Filter for both TECHNICIAN and MAID roles to appear as "Staff"
//       const assignable = allUsers.filter(u => 
//         u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//       );

//       setStaffList(assignable);
//       setIssues(issueRes.data.results || issueRes.data || []);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.error("Error loading data", err);
//       setError(t("Failed to load staff or issues."));
//       setLoading(false);
//     });
//   }, [t]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData((prev) => {
//       const newData = { ...prev, [name]: value };

//       if (name === "issue") {
//         const selectedIssue = issues.find(i => String(i.id) === String(value));
//         newData.room_display = selectedIssue?.room_number || selectedIssue?.room || t("Not specified");
//       }
//       return newData;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(""); 
    
//     try {
//       const payload = {
//         issue: formData.issue,
//         technician: formData.technician,
//         appointment_date: formData.appointment_date,
//         appointment_start: formData.appointment_start,
//         appointment_end: formData.appointment_end,
//       };
      
//       await axiosClient.post("api/appointments/", payload);

//       if (typeof onSave === "function") {
//         onSave();
//       } else {
//         // Redirect if used from the Sidebar/Full page
//         window.location.href = "/"; 
//       }

//     } catch (err) {
//       console.error("Submission Error:", err.response?.data || err.message);
//       setError(t("Error saving appointment. Check if all fields are filled."));
//     }
//   };

//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;

//   return (
//     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2 }}>
//       {/* Modification: Title remains 'ADD TO CALENDAR' */}
//       <Typography variant="h6" mb={3} fontWeight="bold" textAlign="center">
//         {t("ADD TO CALENDAR")}
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("DATE OF APPOINTMENT *")}
//             type="date"
//             name="appointment_date"
//             value={formData.appointment_date}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         {/* MODIFICATION: "Select Doctor" replaced with "Select Staff" */}
//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
//             <Select
//               labelId="staff-select-label"
//               name="technician"
//               value={formData.technician}
//               label={t("Select Staff")}
//               onChange={handleChange}
//             >
//               {staffList.map(staff => (
//                 <MenuItem key={staff.id} value={staff.id}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
//                     <Typography>
//                       {`${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.email}
//                     </Typography>
//                     {/* Visual chips for Technician/Maid matching the Issue log style */}
//                     <Chip 
//                       label={staff.user_role} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ 
//                         ml: 1, 
//                         fontSize: '0.65rem', 
//                         height: '20px',
//                         color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                         borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                       }} 
//                     />
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <FormControl fullWidth required>
//             <InputLabel>{t("Select Issue")}</InputLabel>
//             <Select
//               name="issue"
//               value={formData.issue}
//               label={t("Select Issue")}
//               onChange={handleChange}
//             >
//               {issues.map(issue => (
//                 <MenuItem key={issue.id} value={issue.id}>
//                   {`#${issue.id} - ${issue.title}`}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label={t("ROOM")}
//             value={formData.room_display || t("Select an issue to see room")}
//             InputProps={{ readOnly: true }}
//             variant="filled"
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (START) *")}
//             type="time"
//             name="appointment_start"
//             value={formData.appointment_start}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label={t("TIME OF APPOINTMENT (END) *")}
//             type="time"
//             name="appointment_end"
//             value={formData.appointment_end}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button 
//               onClick={() => (typeof onSave === "function" ? onSave() : window.history.back())} 
//               color="inherit"
//             >
//               {t("CANCEL")}
//             </Button>
//             <Button variant="contained" type="submit">{t("SUBMIT")}</Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AppointmentForm;





import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import DaysCalendar from "../components/DaysCalendar";
import HoursCalendar from "../components/HoursCalendar";
import AppointmentEditModal from "../components/AppointmentEditModal";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Grid,
  Typography,
  Chip
} from "@mui/material";
import { useTranslation } from "react-i18next";

function FullCalendarApp() {
  const { t } = useTranslation();
  const { user } = useStateContext();
  
  const [view, setCalendarView] = useState("dayGridMonth");
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);

  // Form States
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("10:00");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedIssue, setSelectedIssue] = useState("");
  const [roomDisplay, setRoomDisplay] = useState("");

  const [staffList, setStaffList] = useState([]);
  const [issuesList, setIssuesList] = useState([]);

  // Synchronization: Using the SAME FETCH LOGIC as AppointmentForm
  useEffect(() => {
    if (!user) return;
    Promise.all([
      axiosClient.get("auth/users/"), // 🛠️ Using the SAME ENDPOINT
      axiosClient.get("api/issues/")
    ])
      .then(([userRes, issueRes]) => {
        const allUsers = Array.isArray(userRes.data) ? userRes.data : (userRes.data.results || []);
        
        // 🛠️ SAME FILTERING LOGIC
        const assignable = allUsers.filter(u => 
          u.user_role === "TECHNICIAN" || u.user_role === "MAID"
        );

        setStaffList(assignable);
        setIssuesList(issueRes.data.results || issueRes.data || []);
      })
      .catch((err) => console.error("Sync Error:", err));
  }, [user]);

  const getEventList = () => {
    axiosClient.get("/api/appointments/").then((res) => {
      const data = res.data || [];
      const transformed = data.map((a) => ({
        title: `${a.issue_info?.title || 'Issue'} (${a.technician_info?.first_name || 'Staff'})`,
        start: `${a.appointment_date}T${a.appointment_start}`,
        end: `${a.appointment_date}T${a.appointment_end}`,
        id: a.id,
      }));
      setEvents(transformed);
    });
  };

  useEffect(() => { if (user) getEventList(); }, [user]);

  const handleIssueChange = (value) => {
    setSelectedIssue(value);
    const selectedObj = issuesList.find(i => String(i.id) === String(value));
    setRoomDisplay(selectedObj?.room_number || selectedObj?.room || t("Not specified"));
  };

  const handleHourClick = (arg) => {
    const dt = arg.date || new Date(arg.dateStr || arg);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const d = String(dt.getDate()).padStart(2, "0");
    setDate(`${y}-${m}-${d}`);
    setStartTime(String(dt.getHours()).padStart(2, "0") + ":" + String(dt.getMinutes()).padStart(2, "0"));
    setOpen(true);
  };

  const handleSubmit = () => {
    const payload = {
      issue: Number(selectedIssue),
      technician: Number(selectedStaff), 
      appointment_date: date,
      appointment_start: `${startTime}:00`,
      appointment_end: `${endTime}:00`,
    };
    axiosClient.post("/api/appointments/", payload).then(() => {
      getEventList();
      setOpen(false);
    });
  };

  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <Button variant="contained" onClick={() => setCalendarView(view === "dayGridMonth" ? "timeGridDay" : "dayGridMonth")}>
          {view === "dayGridMonth" ? t("Switch to Daily Schedule") : t("Switch to Month View")}
        </Button>
      </Box>

      {view === "dayGridMonth" ? (
        <DaysCalendar events={events} onDateClick={(arg) => { setCalendarView("timeGridDay"); setDate(arg.dateStr); }} onEventClick={(info) => { setSelectedEventId(info.event.id); setOpenEditModal(true); }} />
      ) : (
        <HoursCalendar events={events} onDateClick={handleHourClick} onEventClick={(info) => { setSelectedEventId(info.event.id); setOpenEditModal(true); }} date={date} />
      )}

      {/* ✅ MODAL: EXACT SAME UI AS APPOINTMENT FORM */}
      <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)}>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>{t("ADD TO CALENDAR")}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField fullWidth label={t("DATE OF APPOINTMENT *")} type="date" value={date} onChange={(e) => setDate(e.target.value)} InputLabelProps={{ shrink: true }} />
            </Grid>
            
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>{t("Select Staff")}</InputLabel>
                <Select value={selectedStaff} label={t("Select Staff")} onChange={(e) => setSelectedStaff(e.target.value)}>
                  {staffList.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                        <Typography>
                          {`${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.email}
                        </Typography>
                        {/* 🛠️ SAME CHIP LOGIC */}
                        <Chip 
                          label={staff.user_role} 
                          size="small" 
                          variant="outlined" 
                          sx={{ 
                            ml: 1, 
                            fontSize: '0.65rem', 
                            height: '20px',
                            color: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
                            borderColor: staff.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
                          }} 
                        />
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>{t("Select Issue")}</InputLabel>
                <Select value={selectedIssue} label={t("Select Issue")} onChange={(e) => handleIssueChange(e.target.value)}>
                  {issuesList.map(i => <MenuItem key={i.id} value={i.id}>#{i.id} - {i.title}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label={t("ROOM")} value={roomDisplay} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            <Grid item xs={6}><TextField fullWidth label={t("TIME OF APPOINTMENT (START) *")} type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
            <Grid item xs={6}><TextField fullWidth label={t("TIME OF APPOINTMENT (END) *")} type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpen(false)}>{t("CANCEL")}</Button>
          <Button variant="contained" onClick={handleSubmit}>{t("SUBMIT")}</Button>
        </DialogActions>
      </Dialog>

      <AppointmentEditModal open={openEditModal} id={selectedEventId} handleClose={() => setOpenEditModal(false)} refresh={getEventList} />
    </div>
  );
}

export default FullCalendarApp;